module.exports = __webpack_public_path__ + "static/media/img-destaque-home.cfde8d81.jpg";